// extracted by mini-css-extract-plugin
export default {"container":"FilesList_container__Xqca9","empty":"FilesList_empty__ddM6X"};